module.exports = __webpack_public_path__ + "media/images/top/pap/common/img_inquiry01-6e700a041cc53a31618d5ed8e0efb3fc.png";